import classNames from 'classnames'
import React, { useEffect } from 'react'
import { AdminManagePresidentialChartState } from '../../hooks/use-manage-presidential-chart'

const AdminManagePresidentialChartGeneralData: React.FC<{
  state: AdminManagePresidentialChartState
}> = ({
  state: {
    form: { register, formState, setValue, getValues, watch },
    states,
  },
}) => {
  const state = watch('state')

  const resetRace = () => {
    if (getValues()?.races) {
      const resetedRaces = getValues().races.map((race) => {
        const resetedRace = {
          ...race,
          candidateNames: [],
          candidates: 0,
          parties: race?.politicalParties.map((party) => {
            return {
              ...party,
              candidateNames: [],
              candidates: 0,
            }
          }),
        }
        return resetedRace
      })

      setValue('races', resetedRaces)
    }
  }

  useEffect(() => {
    const selectedState = states.filter((item) => item.id === Number(state))
    if (
      selectedState?.[0]?.name === 'Minnesota' ||
      selectedState?.[0]?.name === 'Wisconsin'
    ) {
      setValue('showCandidateNames', true)
      resetRace()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  return (
    <div className="grid grid-cols-2 gap-x-[80px] gap-y-8 mt-16">
      <div>
        <label
          htmlFor="municipality"
          className="font-medium tracking-widest uppercase"
        >
          Municipality name
        </label>
        <input
          {...register('municipality')}
          type="text"
          id="municipality"
          placeholder="Municipality Name"
          className={classNames(
            'w-full mt-2 px-4 py-3 border rounded-md border-primary-blue',
            {
              'border-red-500 focus:outline-red-500':
                formState?.errors?.municipality,
            }
          )}
        />
        {formState?.errors?.municipality && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.municipality.message}
          </div>
        )}
      </div>
      <div>
        <label
          htmlFor="county"
          className="font-medium tracking-widest uppercase"
        >
          County
        </label>
        <input
          {...register('county')}
          type="text"
          id="county"
          placeholder="County"
          className={classNames(
            'w-full mt-2 px-4 py-3 border rounded-md border-primary-blue',
            {
              'border-red-500 focus:outline-red-500': formState?.errors?.county,
            }
          )}
        />
        {formState?.errors?.county && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.county.message}
          </div>
        )}
      </div>
      <div>
        <label
          htmlFor="state"
          className="font-medium tracking-widest uppercase"
        >
          State
        </label>
        <select
          {...register('state')}
          id="state"
          disabled={states.length === 0}
          className={classNames(
            'px-[15px] mt-2 py-3 w-full border rounded-md border-primary-blue hover:cursor-pointer',
            {
              'border-red-500 focus:outline-red-500': formState?.errors?.state,
            }
          )}
        >
          <option value="" disabled selected>
            Select State
          </option>
          {states.map((state) => (
            <option key={`state-${state.id}`} value={state.id}>
              {state.name}
            </option>
          ))}
        </select>
        {formState?.errors?.state && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.state.message}
          </div>
        )}
      </div>
      <div>
        <label
          htmlFor="precinct"
          className="font-medium tracking-widest uppercase"
        >
          Precinct Number
        </label>
        <input
          {...register('precinct')}
          type="text"
          id="precinct"
          placeholder="Precinct Number"
          className={classNames(
            'w-full mt-2 px-4 py-3 border rounded-md border-primary-blue',
            {
              'border-red-500 focus:outline-red-500':
                formState?.errors?.precinct,
            }
          )}
        />
        {formState?.errors?.precinct && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.precinct.message}
          </div>
        )}
      </div>
      <div>
        <label
          htmlFor="electionDate"
          className="font-medium tracking-widest uppercase"
        >
          Date of election
        </label>
        <input
          {...register('electionDate')}
          type="date"
          id="electionDate"
          placeholder="Select Date"
          className={classNames(
            'w-full mt-2 px-4 py-3 border rounded-md border-primary-blue',
            {
              'border-red-500 focus:outline-red-500':
                formState?.errors?.electionDate,
            }
          )}
        />
        {formState?.errors?.electionDate && (
          <div className="mt-1 text-sm text-red-500">
            {formState.errors.electionDate.message}
          </div>
        )}
      </div>
    </div>
  )
}

export default AdminManagePresidentialChartGeneralData
